// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#MapCopyright {\n    position: absolute;\n    right: 0.5em;\n    bottom: 3em;\n    background-color: rgba(255, 255, 255, 0.5);\n    padding: 0.5em 0;\n    font-size: x-small;\n}\n\n#MapCopyright span {\n    padding: 0 0.5em;\n}\n\n#MapCopyright span:not(:first-child) {\n    border-left: 1px solid #595959;\n}\n", ""]);
// Exports
module.exports = exports;
